import React, { Fragment } from "react";
import Button from "../../components/atoms/Button";
import CheckBox from "../../components/atoms/CheckBox";
import ModalSuccess from "./ModalSuccess";

const ModalTTD = ({ onClick, accDisclaimer, changeDisclaimer, contentDoc, loadingModal, onClose, success, titleSuccess, contentSuccess, closeSuccess }) => {
	return (
		<div className={`kc-modal`}>
			{success ? (
				<ModalSuccess titleSuccess={titleSuccess} contentSuccess={contentSuccess} closeSuccess={closeSuccess} />
			) : (
				<div className="kc-modal-dialog">
					{!contentDoc.loading && (
						<button type="button" className="kc-modal-close" onClick={onClose}>
							<span aria-hidden="true">&times;</span>
						</button>
					)}
					<div className="kc-modal-content">
						{contentDoc.loading ? (
							<div className="spinner-border text-secondary loader" role="status" />
						) : (
							contentDoc.docs && (
								<Fragment>
									<div className="documentRender" dangerouslySetInnerHTML={{ __html: contentDoc.docs.htmlTemplate }} />

									<CheckBox className="mb-3" name="setuju" onChange={(e) => changeDisclaimer()} data={[{ text: "Saya telah membaca dan menyetujui pernyataan disclaimer.", value: accDisclaimer, checked: accDisclaimer }]} />
									{<Button loading={loadingModal} type="button" title={"KONFIRMASI"} color="yellow" width="big-rounded" isDisabled={!accDisclaimer} onClick={onClick} />}
								</Fragment>
							)
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default ModalTTD;
